var map = {
	"./facebook.png": 42556,
	"./github.png": 34719,
	"./instagram.png": 27154,
	"./linkedin.png": 96827,
	"./mexico.png": 34076,
	"./tiktok.png": 15184,
	"./twitter.png": 15622,
	"./website.png": 3276,
	"./youtube.png": 74522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58288;